<template>
  <div>
    <Ibox v-if="valido" :back="'true'" :titulo="'Agregar usuario'">
      <b-col cols="12">
        <h4>Usuario</h4>
      </b-col>
      <FormGroup
          cols="6"
          label="Nombre">
        <input type="text" class="form-control" v-model="usuario.nombre_usuario">
      </FormGroup>
      <FormGroup
          cols="6"
          label="Permisos">
        <v-select
            v-model="usuario.permiso"
            :clearable=false
            :reduce="permiso=>permiso.v"
            :options="[
            {v:'1',label:'Ver y editar'},
            {v:'0',label:'Ver'},
          ]">
        </v-select>
      </FormGroup>
      <FormGroup
          cols="6"
          label="Correo">
        <input type="text" class="form-control" v-model="usuario.correo">
      </FormGroup>
      <FormGroup
          cols="6"
          label="Repita correo">
        <input type="text" class="form-control" autoComplete="off" v-model="usuario.repita_correo">
      </FormGroup>
      <FormGroup
          cols="6"
          label="Contraseña">
        <input type="password" class="form-control" autoComplete="new-password" v-model="usuario.pass">
      </FormGroup>
      <FormGroup
          cols="6"
          label="Repita contraseña">
        <input type="password" class="form-control" autoComplete="new-password" v-model="usuario.repita_pass">
      </FormGroup>
      <b-col cols="12">
        <h3>Perfiles</h3>
      </b-col>
      <FormGroup
        cols="2"
        label="Inspector"
        :is_loading=loading>
        <CheckBox v-model='isInspector' @update-value="setInspector"></CheckBox>
      </FormGroup>
      <FormGroup
        cols="2"
        label="Ejecutor"
        :is_loading=loading>
        <CheckBox v-model='isEjecutor' @update-value="setEjecutor"></CheckBox>
      </FormGroup>
      <FormGroup
          cols="2"
          label="Administrador"
          :is_loading=loading>
        <CheckBox v-model='isAdministrador' @update-value="setAdministrador"></CheckBox>
      </FormGroup>
      <FormGroup
        cols="2"
        label="Administrador sucursal"
        :is_loading=loading>
        <CheckBox v-model='isAdministradorSucursal' @update-value="setAdministradorSucursal"></CheckBox>
      </FormGroup>
      <FormGroup
        cols="2"
        label="Trabajador documentos"
        :is_loading=loading>
        <CheckBox v-model='isTrabajador' @update-value="setTrabajador"></CheckBox>
      </FormGroup>
      <b-col v-if="utils.tienePermiso()" cols="12" align="right">
        <b-button v-if="!loading" variant="primary" v-on:click="agregarUsuario()">Agregar</b-button>
        <b-button v-else variant="primary">
          <Loading :size="'1'" :text="'Agregando usuario'"/>
        </b-button>
      </b-col>
    </Ibox>
    <Ibox v-else :back="'true'" :titulo="'Agregar usuario'">
      <b-col cols="12">
        <h4>Error</h4>
      </b-col>
    </Ibox>
  </div>
</template>

<script>
import {userService, globales} from "@/services";
import {utils} from "@/helpers";

export default {
  name: 'Agregar',
  data() {
    return {
      valido: true,
      utils,
      usuario: {
        id_usuario_responsable: this.$store.state.usuario.id_usuario,
        id_cliente: this.$store.state.usuario.id_cliente,
        nombre_usuario: null,
        pass:null,
        repita_pass:null,
        permiso: '1',
        correo: null,
        repita_correo: null,
        perfiles:[]
      },
      isInspector:false,
      isEjecutor:false,
      isAdministrador:null,
      isAdministradorSucursal:null,
      isTrabajador:null,
      loading: false
    }
  },
  mounted(){
    this.setInspector(true);
    this.setEjecutor(true);
  },
  methods: {
    setInspector(value){
      this.isInspector = value;
      if(value){
        this.usuario.perfiles = this.usuario.perfiles.filter(data => data.id_perfil != globales.perfil.inspector);
        this.usuario.perfiles.push({id_perfil:globales.perfil.inspector, nombre_perfil:'Inspector'});
      }else{
        this.usuario.perfiles = this.usuario.perfiles.filter(data => data.id_perfil != globales.perfil.inspector);
      }
    },
    setEjecutor(value){
      this.isEjecutor = value;
      if(value){
        this.usuario.perfiles = this.usuario.perfiles.filter(data => data.id_perfil != globales.perfil.ejecutor);
        this.usuario.perfiles.push({id_perfil:globales.perfil.ejecutor, nombre_perfil:'Ejecutor'});
      }else{
        this.usuario.perfiles = this.usuario.perfiles.filter(data => data.id_perfil != globales.perfil.ejecutor);
      }
    },
    setAdministrador(value){
      this.isAdministrador = value;
      if(value){
        this.usuario.perfiles = this.usuario.perfiles.filter(data => data.id_perfil != globales.perfil.admin_cliente);
        this.usuario.perfiles.push({id_perfil:globales.perfil.admin_cliente, nombre_perfil:'Administrador'});
      }else{
        this.usuario.perfiles = this.usuario.perfiles.filter(data => data.id_perfil != globales.perfil.admin_cliente);
      }
    },
    setAdministradorSucursal(value) {
      this.isAdministradorSucursal = value;
      if(value){
        this.usuario.perfiles = this.usuario.perfiles.filter(data => data.id_perfil != globales.perfil.admin_sucursal);
        this.usuario.perfiles.push({id_perfil:globales.perfil.admin_sucursal, nombre_perfil:'Administrador sucursal'});
      }else{
        this.usuario.perfiles = this.usuario.perfiles.filter(data => data.id_perfil != globales.perfil.admin_sucursal);
      }
    },
    setTrabajador(value) {
      this.isTrabajador = value;
      if(value){
        this.usuario.perfiles = this.usuario.perfiles.filter(data => data.id_perfil != globales.perfil.trabajador);
        this.usuario.perfiles.push({id_perfil:globales.perfil.trabajador, nombre_perfil:'Trabajador'});
      }else{
        this.usuario.perfiles = this.usuario.perfiles.filter(data => data.id_perfil != globales.perfil.trabajador);
      }
    },
    agregarUsuario() {
      if (globales.validarCorreo(this.usuario.correo)) {
        if (this.usuario.nombre_usuario && this.usuario.correo) {
          if (this.usuario.correo == this.usuario.repita_correo) {
            if (this.usuario.pass == this.usuario.repita_pass) {
              if (this.usuario.perfiles.length == 0) {
                utils.alerta({msg: 'Debe elegir al menos un perfil para el usuario', status: 'warning'});
                this.loading = false;
              } else {
                this.loading = true;
                userService.postUsuario(this.usuario).then(respuesta => {
                  utils.alerta(respuesta);
                  this.loading = false;

                  if (respuesta.status == "success") {
                    this.$router.go(-1);
                  }
                });
              } 
            } else {
              utils.alerta({msg: 'Contraseñas deben ser iguales', status: 'warning'});
            }
          } else {
            utils.alerta({msg: 'Correos deben ser iguales', status: 'warning'});
          }
        } else {
          utils.alerta({msg: 'Faltan campos obligatorios', status: 'warning'});
        }
      } else {
        utils.alerta({msg: 'Correo invalido', status: 'warning'});
      }
    },
  }
}
</script>

<style scoped>
</style>
